<template>
  <div class="pa-4">
    <!--    <div class="py-1 px-1">-->
    <!--      <v-autocomplete-->
    <!--        outlined-->
    <!--        dense-->
    <!--        :items="paths"-->
    <!--        placeholder="جستجو در درخت"-->
    <!--        v-model="filterNode"-->
    <!--        @input="updateTree"-->
    <!--        hide-details-->
    <!--      ></v-autocomplete>-->
    <!--    </div>-->
    <v-treeview
      rounded
      hoverable
      activatable
      transition
      :items="items"
      :item-key="Def.idField || 'ID'"
      :item-text="Def.nameField || 'Label'"
      @update:active="activeNode"
    >
      <template #append="{ item, active }">
        <v-menu
          v-if="active && !item.editing"
          min-width="90"
          close-on-content-click
          class="pa-2"
        >
          <template #activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark>
                mdi-dots-vertical
              </v-icon>
            </v-btn>
          </template>
          <v-list class="pa-0">
            <AppButton
              v-for="action in def.nodeActions"
              :key="action.id"
              width="100%"
              text
              :def="action"
              :model="item"
              @onSubmitDelete="click($event, { mode: action.name, item })"
              @onSubmitEdit="click($event, { mode: action.name, item })"
              @onSubmit="click($event, { mode: action.name, item })"
              @click.native="selectNode(item)"
            />
          </v-list>
        </v-menu>
      </template>
      <template #prepend="{ item, open }">
        <v-icon>
          {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
        </v-icon>
      </template>
      <template
        slot="label"
        slot-scope="{ item }"
      >
        <v-text-field
          v-if="item.editing"
          ref="nameInput"
          v-model="item.newName"
          @blur="rename(item)"
          @keyup.esc="cancel(item)"
          @keyup.enter="rename(item)"
        ></v-text-field>
        <div
          v-else
          @click="selectNode(item)"
        >
          {{ item['Label'] || item['Name'] }}
        </div>
      </template>
    </v-treeview>
  </div>
</template>

<script>
import {invokeFn, submitFormData} from "@/apis";
import AppButton from "../library/action/AppButton";

export default {
  name: "FolderTree",
  components: {AppButton},
  props: ["def", "model"],
  data: (vm) => ({
    paths: [],
    filterNode: "",
    items: [],
    open: [],
    active: [],
    cachedItems: [],
    Def: vm.def
  }),
  created() {
    this.$watch("model.folderId", (nv, ov) => {
      if(!nv) {
        this.model.folderId = ov;
      }
    })
  },
  
  async mounted() {
    if (!this.Def.idField)
      this.Def.idField = "ID"
    
    if (!this.Def.pidField)
      this.Def.pidField = "PID"
    
    if (!this.Def.nameField)
      this.Def.nameField = "Label"
    
    if (!this.Def.entity)
      this.Def.entity = {kind: "TEntity", name: "ECore.Cmn.Folder"};
    
    await this.getData();
  },
  methods: {
    activeNode(ID) {
      this.$emit("active", ID);
    },
    async getData() {
      const list = await invokeFn(this.def.treeFn.id, {subjectName: this.def.name});

      const map = list.reduce((m, i) => Object.assign(m, {[i[this.Def.idField]]: i}), {})

      const root = []

      const moveToParent = (node) => {
        if (node[this.Def.pidField] in map) {
          const parent = map[node[this.Def.pidField]]
          if (!parent.children)
            parent.children = []
          parent.children.push(node)
        } else {
          root.push(node)
        }
      }

      list.forEach(i => {
        i.editing = false
        moveToParent(i)
      });

      this.items = root;
      // this.createPaths(this.items);
    },
    createPaths(parent, temp) {
      parent.forEach(p => {
        this.paths.push(p[this.def.nameField]);
        if(p.children) {
          p.children.forEach(pc => {
            if(pc.children) {
              const path = temp ? `${temp}/${p[this.def.nameField]}/${pc[this.def.nameField]}` : `${p[this.def.nameField]}/${pc[this.def.nameField]}`;
              this.paths.push(path);
              this.createPaths(pc.children, path);
            } else {
              this.paths.push(`${p[this.def.nameField]}/${pc[this.def.nameField]}`);
            }
          })
        }
      })
    },
    updateTree() {
      const filter = this.filterNode;
      const id = filter && !filter.includes("/") ? filter : filter.split("/").pop();
      let node = null;
      const label = this.def.nameField;
      function findID(parent) {
        parent.forEach(p => {
          if(p[label] === id) node = p;
          else if(p.children) {
            p.children.map(pc => {
              if(pc[label] === id) {
                node = pc;
                return;
              } else if(pc.children){
                findID(pc.children)
              }
            })
          }
        })
      }
      findID(this.cachedItems || this.items);
      this.items = [node]
    },
    selectNode(item) {
      this.model.folderId = item.ID
      this.model.hasChildren = !!item.hasChild && item.children[item.children.length-1].ID + 1
      this.$emit("active", item.ID);
    },
    async click(payload, {mode, item}) {
      await this[mode](item, payload);
      await this.getData();
    },

    async Create(item) {
      if (!item.children)
        this.$set(item, "children", []);
      this.$nextTick(() => {
        this.model.hasChildren++;
      });
      // const newItem = {
      //   ...payload,
      //   parent: item,
      //   editing: false
      // }
      // console.log(newItem)
      // item.children.push(newItem)
      //
      // this.open.push(item[this.def.idField]);
      // this.active = [newItem[this.def.idField]];
      // this.$nextTick(() => {
      //   this.$refs.nameInput.focus()
      // })
    },
    
    async Edit() {
      // item.newName = item[this.def.nameField]
      // item.editing = true
      // this.$nextTick(() => {
      //   this.$refs.nameInput.focus()
      // });
    },
    
    async Delete() {
      // const index = item.parent.children.indexOf(item)
      // item.parent.children.splice(index, 1)
      // this.active = index > 0 ? [item.parent.children[index-1][this.def.idField]] : [item.parent[this.def.idField]]
    },

    async rename(item) {
      await this.save(item)

      item.editing = false
    },
    
    async cancel(item) {
      if (item[this.def.idField] == null) {
        await this.delete(item)
      } else {
        item.editing = false
      }
    },
    
    async save(item) {
      Object.assign(item, await submitFormData(this.def.entity.name, {[this.def.pidField]: item[this.def.pidField], [this.def.nameField]: item.newName}, item[this.def.idField], `${this.def.entity.name}AutoForm`))
    }
  },
}
</script>

<style>
.v-treeview-node__root {
  margin: 0!important;
  padding: 0 4px!important;
}
.v-text-field--filled.v-input--dense.v-text-field--single-line > .v-input__control > .v-input__slot, .v-text-field--filled.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot,
.v-text-field--filled.v-input--dense.v-text-field--outlined.v-text-field--filled > .v-input__control > .v-input__slot, .v-text-field--full-width.v-input--dense.v-text-field--single-line > .v-input__control > .v-input__slot, .v-text-field--full-width.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot, .v-text-field--full-width.v-input--dense.v-text-field--outlined.v-text-field--filled > .v-input__control > .v-input__slot, .v-text-field--outlined.v-input--dense.v-text-field--single-line > .v-input__control > .v-input__slot, .v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot, .v-text-field--outlined.v-input--dense.v-text-field--outlined.v-text-field--filled > .v-input__control > .v-input__slot{
  min-height: 36px!important;
}
</style>